module.exports = __webpack_public_path__ + "static/media/section_2_A.2f4dc067.png";